<template>
  <form class="form form-filter-ph mb-0">
    <div class="form-group" v-show="show">
      <label>Filtruj przedstawicieli</label>
      <div class="select-wrapper">
        <span v-if="ph_slug === null" class="select-placeholder">Wybierz przedstawiciela</span>
        <select v-model="ph_slug" @change="handleFilter($event)">
          <option v-for="item in phs" :value="item.slug">{{ item.full_name }}</option>
        </select>
      </div>
    </div>
  </form>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'FormFilterPh',
    data(){
      return {
        show: false
      }
    },
    computed: {
      ...mapState({
        phs: state => state.clients.phs,
      }),
      ph_slug: {
        set(selectedPhSlug) {
          this.$store.commit('clients/ASM_SET_CURRENT_PH', selectedPhSlug)
        },
        get() {
          return this.$store.state.clients.currentPh || null
        }
      }
    },
    mounted(){
      this.show = true;
    },
    methods: {
      handleFilter(e){
        let payload = {'ph_slug' : this.ph_slug};
        this.$store.dispatch('clients/PH_CLIENTS_REQUEST', payload);
      }
    }
  }
</script>